








































import {Component, Prop, Vue} from 'vue-property-decorator';
import {IProjectMetadata} from '@/interfaces/report';

@Component({
  name: 'ProjectBreadcrumb',
})
export default class ProjectBreadcrumb extends Vue {
  public availableProjects!: IProjectMetadata[];

  @Prop() readonly projectName!: string;

  @Prop() readonly projectId!: string;

  @Prop() readonly moduleName!: string | undefined;

  @Prop() readonly moduleId!: string | undefined;

  @Prop() readonly scenarioName!: string | undefined;

  @Prop() readonly scenarioTypeText!: string | undefined;

  @Prop() readonly icon!: string | undefined;

  @Prop({default: 'lg'}) readonly iconSize!: string | undefined;
}
